import apiService, { APIResponse } from "./axios";

import { RootState, store } from "../../store/store"; // Pfad zu deinem Store-File
import { setOpeningtimes, setStations } from "../../store/orm/stations";

import { setSelectedStation } from "../../store/orm/userSession";

import {
  setEndDate,
  setEndTime,
  setStartDate,
  setStartTime,
} from "../../store/orm/userSession";

import { getParameter } from "../../store/app/general";

// import userSession from "../app/userSession.ts.old";
import {
  formatDate,
  formatDatetime,
  formatDatetimeZ,
  formatTime,
} from "../../utils/formater";

import { Station } from "../../store/orm/stations";
import { useSelector } from "react-redux";

export interface Openingtimes {
  min_start_date: string;
  selected_start_date: string;
  max_start_date: string;
  min_end_date: string;
  selected_end_date: string;
  max_end_date: string;
  date_Format: string;
  using_offer_times: string;
  start_time_config: string[];
  end_time_config: string[];
  closed_days_config: any[];
  start_closed_days_config: any[];
  end_closed_days_config: any[];
}

class ORMStationsService {
  async fetchStations() {
    const response: APIResponse<any> =
      await apiService.get<any>("api/rent/stations");

    if (response.error) {
      console.error("Fehler:", response.message);
      return;
    }

    const state = store.getState();
    const shouldPreselect = getParameter(state, "BORM_PRESELECT_STATION") == 1;

    const selectedStationId = state.userSession.selectedStation;
    const stations = response as Station[];

    store.dispatch(setStations(stations));

    if (shouldPreselect || selectedStationId) {
      store.dispatch(
        setSelectedStation({
          type: "start",
          stationId: selectedStationId || stations[0].id,
          shouldPreselect,
        }),
      );
    }
  }

  async fetchOpeningTimes(state: any, datenow = false) {
    const startStation = state.selectedStation;
    const endStation = state.selectedStationEnd || state.selectedStation;
    const startDate = state.startDate;
    const startTime = state.startTime;
    const endDate = state.endDate;
    const endTime = state.endTime;
    console.log(startDate);

    const payload = {
      clientDateStartingPoint: formatDatetime(Date.now()),
      startstation: startStation,
      endstation: endStation,
      selectedStartDateTime:
        startDate && startTime && !datenow
          ? formatDatetime(`${startDate}T${startTime}`, true)
          : formatDatetime(Date.now(), true),
      selectedEndDateTime:
        endDate && endTime && !datenow
          ? formatDatetime(`${endDate}T${endTime}`, true)
          : formatDatetime(Date.now(), true),
    };
    const response: APIResponse<any> = await apiService.get<any>(
      "api/rent/stations/opentimes",
      payload,
    );

    const opentimes = response as Openingtimes;

    if (datenow) return opentimes;

    store.dispatch(setOpeningtimes(opentimes));
    store.dispatch(setStartDate(formatDate(opentimes.selected_start_date)));
    store.dispatch(setEndDate(formatDate(opentimes.selected_end_date)));
    store.dispatch(
      setStartTime(formatTime(opentimes.selected_start_date + "Z")),
    );
    store.dispatch(setEndTime(formatTime(opentimes.selected_end_date + "Z")));

    if (response.error) {
      console.error("Fehler:", response.message);
      return;
    }
  }
}

const ormStationsService = new ORMStationsService();
export default ormStationsService;
